export const pointRequestHistory = {
  loyaltyPointRequestHistory: "Loyalty Point Request History",
  pointRequestHistory: "Point Request History",
  search: "Search",
  from: "From",
  to: "To",
  advanceFilter: "Advanve Filter",
  selectStatus: "SELECT STATUS",
  approve: "APPROVED",
  rejected: "REJECTED",
  reject: "REJECTED",
  pending: "PENDING",
  close: "close",
  filter: "filter",
  username: "USERNAME",
  amount: "AMOUNT",
  status: "STATUS",
  createdDate: "CREATED DATE",
  updatedDate: "UPDATED DATE",
};
